import type { Subscription } from 'digicel-kaizen-library';
import { SubscriptionsActionType } from './types';

export type SubscriptionsStateType = {
  subscriptionsByOuid: SubscriptionsByOuidType,
  subscriptionToUpdateOuid: string,
};

const initialState = {
  subscriptionsByOuid: {},
  subscriptionToUpdateOuid: '',
};

export default function reducer(
  state: SubscriptionsStateType = initialState,
  action: SubscriptionsActionType
): SubscriptionsStateType {
  if (action.type === 'SET_PHONE_LINES') {
    const phoneLinesEditing = action.payload.updatedPhoneLines;
    const subscriptionsToUpdate = {};

    phoneLinesEditing.forEach(phoneLineEditing => {
      const number = phoneLineEditing.number;
      const alias = phoneLineEditing.alias;

      if (!number) return;

      // $FlowFixMe Object.values
      let subscription: Subscription = Object.values(state.subscriptionsByOuid).find(
        // $FlowFixMe Object.values
        (subscription: Subscription) => subscription?.line.number === number
      );

      if (!subscription) return;

      if (alias !== undefined) {
        subscription = {
          ...subscription,
          line: {
            ...subscription.line,
            alias,
          },
        };
      }
      subscriptionsToUpdate[subscription.ouid] = subscription;
    });

    return { ...state, subscriptionsByOuid: subscriptionsToUpdate };
  } else if (action.type === 'SUBSCRIPTION_FETCH_ALL_SUCCESS') {
    const subscriptionsByOuid = action.payload.subscriptionsByOuid || {};

    return { ...state, subscriptionsByOuid };
  } else if (action.type === 'SET_SUBSCRIPTION_TO_UPDATE') {
    const { subscriptionToUpdateOuid } = action.payload;

    return { ...state, subscriptionToUpdateOuid };
  } else if (action.type === 'UPDATE_SELECTED_SUBSCRIPTION') {
    const { subscriptionsByOuid, subscriptionToUpdateOuid } = state;
    const { newOffer } = action.payload;

    if (newOffer) {
      const subscriptionToUpdate = state.subscriptionsByOuid[subscriptionToUpdateOuid];
      subscriptionToUpdate.plan = newOffer.plan;
      subscriptionToUpdate.options = newOffer.options;
      subscriptionToUpdate.price = newOffer.price;
      subscriptionsByOuid[subscriptionToUpdateOuid] = subscriptionToUpdate;
    }

    return { ...state, subscriptionsByOuid };
  }

  return state;
}
